export default __webpack_public_path__ + "static/media/Sort.e74e33c6.svg";